module.exports = __webpack_public_path__ + "static/media/Amazon.09c965a1.svg";